module.exports = __webpack_public_path__ + "static/blockchaindevelopment-min-32a5e1b46125b3cd76e0b8ff46e96875.jpg";